module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/onesence-5-94f8558e1f2efb14836c82396367b2e4.webp";